import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Favicon from "react-favicon";
import { Modal } from "react-bootstrap";
import InputTitle from "./components/InputTitle";
import Button from "./components/Button";
import {
  getStageScreen,
  updateScreenPage,
  createKycForExistingUser,
  resetIsKycStatusCompleted,
} from "../../redux/navigation/navigationAction";
//Designs
// 101
import HalfPageDesign101 from "./design1/HalfPageDesign";
import LeftBarDesign101 from "./design1/LeftBarDesign";

// 102
import HalfPageDesign102 from "./design2/HalfPageDesign";
import LeftBarDesign102 from "./design2/LeftBarDesign";

// 103
import HalfPageDesign103 from "./design3/HalfPageDesign";
import LeftBarDesign103 from "./design3/LeftBarDesign";

// 104
import HalfPageDesign104 from "./design4/HalfPageDesign";
import LeftBarDesign104 from "./design4/LeftBarDesign";

// 105
import HalfPageDesign105 from "./design5/HalfPageDesign";
import LeftBarDesign105 from "./design5/LeftBarDesign";

// 106
import HalfPageDesign106 from "./design6/HalfPageDesign";
import LeftBarDesign106 from "./design6/LeftBarDesign";

// 107
import HalfPageDesign107 from "./design7/HalfPageDesign";
import LeftBarDesign107 from "./design7/LeftBarDesign";

// 108
import HalfPageDesign108 from "./design8/HalfPageDesign";
import LeftBarDesign108 from "./design8/LeftBarDesign";

// 109
import HalfPageDesign109 from "./design9/HalfPageDesign";
import LeftBarDesign109 from "./design9/LeftBarDesign";

// 110
import HalfPageDesign110 from "./design10/HalfPageDesign";
import LeftBarDesign110 from "./design10/LeftBarDesign";

// import pages
import LoginRegister from "./pages/LoginRegister";
import Address from "./pages/Address";
import BankVerification from "./pages/BankVerification";
import BrokerPayment from "./pages/BrokerPayment";
import ESignature from "./pages/ESignature";
import IncomeProof from "./pages/IncomeProof";
import PanAddress from "./pages/PanAddress";
import PersonalData from "./pages/PersonalData";
import Review from "./pages/Review";
import Signature from "./pages/Signature";
import VisualVerification from "./pages/VisualVerification";
import Nominee from "./pages/Nominee";
import DDPI from "./pages/DDPI";
import TariffScheme from "./pages/TariffScheme";
import BrokerageScheme from "./pages/BrokerageScheme";
import NonDepositoryParticipant from "./pages/NonDepositoryParticipant";

import { CREATE_PAN_SUCCESS } from "../v1/pages/Address/redux/type";
import {
  setThemeColors,
  setGradientColors,
  setCancelCheque,
  setBankStatement,
  setExchangeSegment,
  setNomineeProofvalidate,
  setReactivationProof,
  setAccountClosureScreen,
} from "./redux/actions";
import JointHolder from "./pages/JointHolder";

function HalfPageDesign(props) {
  const { themeTemplate } = useSelector((state) => state.theme);

  switch (themeTemplate) {
    case "101":
      return <HalfPageDesign101 {...props} />;
    case "102":
      return <HalfPageDesign102 {...props} />;
    case "103":
      return <HalfPageDesign103 {...props} />;
    case "104":
      return <HalfPageDesign104 {...props} />;
    case "105":
      return <HalfPageDesign105 {...props} />;
    case "106":
      return <HalfPageDesign106 {...props} />;
    case "107":
      return <HalfPageDesign107 {...props} />;
    case "108":
      return <HalfPageDesign108 {...props} />;
    case "109":
      return <HalfPageDesign109 {...props} />;
    case "110":
      return <HalfPageDesign110 {...props} />;
    default:
      return <HalfPageDesign101 {...props} />;
  }
}

function LeftBarDesign(props) {
  const { themeTemplate } = useSelector((state) => state.theme);

  switch (themeTemplate) {
    case "101":
      return <LeftBarDesign101 {...props} />;
    case "102":
      return <LeftBarDesign102 {...props} />;
    case "103":
      return <LeftBarDesign103 {...props} />;
    case "104":
      return <LeftBarDesign104 {...props} />;
    case "105":
      return <LeftBarDesign105 {...props} />;
    case "106":
      return <LeftBarDesign106 {...props} />;
    case "107":
      return <LeftBarDesign107 {...props} />;
    case "108":
      return <LeftBarDesign108 {...props} />;
    case "109":
      return <LeftBarDesign109 {...props} />;
    case "110":
      return <LeftBarDesign110 {...props} />;
    default:
      return <LeftBarDesign101 {...props} />;
  }
}

function DesignV1() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isRelationShip, setIsRelationShip] = useState(false);
  const [relationshipForm, setRelationshipForm] = useState({
    relationship: "Spouse",
  });
  const optionsBelong = [
    "Self",
    "Spouse",
    "Dependent Parent",
    "Dependent Child",
  ];

  const favicon = window.sessionStorage.getItem("favicon");
  const isCloseKyc = sessionStorage.getItem("closeKYC");
  const isModifyKyc = sessionStorage.getItem("modifyKYC");
  const navigation = useSelector((state) => state.navigation);
  const jointholder = useSelector((state) => state.jointholder);
  const { loading } = useSelector((state) => state.common);
  const { setforcefully, isKycStatusCompleted } = useSelector(
    (state) => state.navigation
  );

  useEffect(() => {
    const token = window.sessionStorage.getItem("token");
    const theme = window.sessionStorage.getItem("theme_color_pallate");
    const gradient = window.sessionStorage.getItem("gradientColor");
    const cancelCheque = window.sessionStorage.getItem(
      "cancel_cheque_mandatory"
    );
    const bankStatement = window.sessionStorage.getItem(
      "statement_passbook_mandatory"
    );
    const hasNomineeProofValidate = window.sessionStorage.getItem(
      "hasNomineeProofValidate"
    );
    const hasReactivationProof = window.sessionStorage.getItem(
      "hasReactivationProof"
    );
    const accountClosureScreen = window.sessionStorage.getItem(
      "accountClosureScreen"
    );
    const exchangeSegment = window.sessionStorage.getItem("exchangeSegment");
    if (theme && gradient) {
      dispatch(setThemeColors(JSON.parse(theme)));
      dispatch(setGradientColors(JSON.parse(gradient)));
    }
    cancelCheque && dispatch(setCancelCheque(JSON.parse(cancelCheque)));
    bankStatement && dispatch(setBankStatement(JSON.parse(bankStatement)));
    hasNomineeProofValidate &&
      dispatch(setNomineeProofvalidate(JSON.parse(hasNomineeProofValidate)));
    hasReactivationProof &&
      dispatch(setReactivationProof(JSON.parse(hasReactivationProof)));
    accountClosureScreen &&
      dispatch(setAccountClosureScreen(JSON.parse(accountClosureScreen)));
    exchangeSegment &&
      dispatch(setExchangeSegment(JSON.parse(exchangeSegment)));
    if (token) dispatch(getStageScreen());
  }, [dispatch]);

  useEffect(() => {
    if (!setforcefully) {
      let { kycStatus, navigationPage } = navigation;
      if (kycStatus) {
        for (let i in kycStatus) {
          let key = Object.keys(kycStatus[i]);
          if (kycStatus[i][key[0]]) {
            if (
              kycStatus[i][key[0]]["status"] == 1 &&
              key[0] == navigationPage
            ) {
              dispatch(updateScreenPage());
            }
          }
        }
      }
      if (navigation?.kycStatus?.[0]?.PAN?.pan_doc_verified === 1) {
        dispatch({ type: CREATE_PAN_SUCCESS });
      }
    }
  }, [navigation]);
  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
  API_URL_NEW = API_URL_NEW
    ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
    : "";
  if (!API_URL_NEW) {
    return (
      <div className="container">
        <div className="col-md-12 mt-5">
          <div className="text-center display-4">
            You are not authorised to access this page
          </div>
        </div>
      </div>
    );
  }

  const getScreen = (screen) => {
    let result = "";
    switch (screen) {
      case "PAN":
        history.push("/pan");
        // result = <LeftBarDesign innerDesign={<PanAddress />} />;
        break;
      case "Address":
        history.push("/address");
        // result = <LeftBarDesign innerDesign={<Address />} />;
        break;
      case "PersonalData":
        history.push("/personal-data");
        // result = <LeftBarDesign innerDesign={<PersonalData />} />;
        break;
      case "BankVerification":
        history.push("/bank-verification");
        // result = <LeftBarDesign innerDesign={<BankVerification />} />;
        break;
      case "SignatureUpload":
        history.push("/signature");
        // result = <LeftBarDesign innerDesign={<Signature />} />;
        break;
      case "VisualVerification":
        history.push("/visual-verification");
        // result = <LeftBarDesign innerDesign={<VisualVerification />} />;
        break;
      case "IncomeProof":
        history.push("/income-proof");
        // result = <LeftBarDesign innerDesign={<IncomeProof />} />;
        break;
      case "Review":
        history.push("/review");
        // result = <LeftBarDesign innerDesign={<Review />} />;
        break;
      case "ESignature":
        history.push("/esignature");
        // result = <LeftBarDesign innerDesign={<ESignature />} />;
        break;
      case "BrokerPayment":
        history.push("/broker-payment");
        // result = <LeftBarDesign innerDesign={<BrokerPayment />} />;
        break;
      case "Nomination":
        history.push("/nominee");
        // result = <LeftBarDesign innerDesign={<Nominee />} />;
        break;
      case "DDPI":
        history.push("/ddpi");
        // result = <LeftBarDesign innerDesign={<DDPI />} />;
        break;
      case "TariffScheme":
        history.push("/tariff-scheme");
        // result = <LeftBarDesign innerDesign={<TariffScheme />} />;
        break;
      case "BrokerageScheme":
        history.push("/brokerage-scheme");
        // result = <LeftBarDesign innerDesign={<BrokerageScheme />} />;
        break;
      case "NonDepositoryParticipant":
        history.push("/non-depository-participant");
        // result = <LeftBarDesign innerDesign={<NonDepositoryParticipant />} />;
        break;
      case "JointHolder":
        history.push("/joint-holder");
        // result = <LeftBarDesign innerDesign={<JointHolder />} />;
        break;
      default:
        result = <HalfPageDesign innerDesign={<LoginRegister />} />;
        break;
    }
    return result;
  };

  const onSubmitKycStatus = () => {
    const formData = new FormData();
    formData.append("relationship", relationshipForm.relationship);
    dispatch(createKycForExistingUser(formData));
  };

  const handleKYCAction = (type) => {
    if (type === "Yes") {
      setIsRelationShip(true);
    } else {
      dispatch(resetIsKycStatusCompleted());
    }
  };

  return (
    <>
      {favicon && <Favicon url={favicon} />}
      {loading && (
        <div
          style={{
            position: "absolute",
            zIndex: 9999,
            top: 0,
            left: 0,
            right: 0,
            height: "100%",
            background: "rgba(0,0,0,0.8)",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          <div style={{ height: "30%" }}></div>
          <div
            className="spinner-grow text-success"
            role="status"
          >
            <span className="sr-only">Loading...</span>
          </div>
          <div className="text-white">Loading...</div>
        </div>
      )}
      {getScreen(
        isCloseKyc || isModifyKyc
          ? ""
          : jointholder.showJointholderFlow
          ? "JointHolder"
          : navigation?.navigationPage
      )}
      {isKycStatusCompleted && (
        <Modal show={isKycStatusCompleted}>
          <Modal.Header>
            <Modal.Title>
              {isRelationShip ? "Select Relationship" : "Create Another KYC"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {isRelationShip ? (
              <div className="col-md-12 mt-4 mb-4 d-flex flex-column justify-content-end">
                <div>
                  <InputTitle title="Relationship Belongs To" />
                  <select
                    style={{
                      width: "100%",
                      border: 0,
                      borderBottomWidth: 1,
                      borderBottomColor: "black",
                      borderBottomStyle: "solid",
                      outline: 0,
                    }}
                    value={relationshipForm.relationship}
                    onChange={(e) =>
                      setRelationshipForm({ relationship: e.target.value })
                    }
                  >
                    {optionsBelong.map((item, key) => (
                      <option
                        key={key}
                        disabled={item === "Self"}
                      >
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            ) : (
              <h6>
                Do you want to proceed with creating another KYC using the same
                mobile number and email address?
              </h6>
            )}
          </Modal.Body>
          <Modal.Footer>
            {isRelationShip ? (
              <Button
                title="Submit"
                handleClick={() => onSubmitKycStatus()}
              />
            ) : (
              <>
                <Button
                  title="No"
                  handleClick={() => handleKYCAction("No")}
                />
                <Button
                  title="Yes"
                  handleClick={() => handleKYCAction("Yes")}
                />
              </>
            )}
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
export default DesignV1;
